import axiosClient from "api/axios_client.js";

const SOURCE = "/reminder-builder/reminder-setup/source";
const CHANNEL = "/reminder-builder/reminder-setup/channel";
const TRIGGER = "/reminder-builder/reminder-library/trigger";

// Calls shared by Reminder Setup, Library and Designer (source, channel and trigger pickers, modules).
const apiReminderBuilder = {
  // Active sources for dropdowns, each with has_reference. params: { status?, module_key? }
  getSourceOptions: (params) => axiosClient.get(`${SOURCE}/get-all`, { params }),
  // One source with its fields.
  getSource:        (id)     => axiosClient.get(`${SOURCE}/get-by-id/${id}`),
  // The fixed module list (module_key of sources and broadcast triggers).
  getModuleKeys:    ()       => axiosClient.get(`${SOURCE}/get-module-keys`),
  // Active channels, each with its template_schema and config_schema.
  getChannelOptions: ()      => axiosClient.get(`${CHANNEL}/get-all`),
  // Active triggers (with params, type and source). params: { status?, trigger_type?, source_fid? }
  getTriggerOptions: (params) => axiosClient.get(`${TRIGGER}/get-all`, { params }),
};

export default apiReminderBuilder;
